"use client";
import React, { useRef } from "react";
import { BannerModel } from "@/types/banner";
import Banner from "./banner";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../ui/carousel";
import { cn } from "@/lib/utils";
import { useLocale } from "next-intl";
import Autoplay from "embla-carousel-autoplay";

const BannersCarousel = ({ banners }: { banners: BannerModel[] }) => {
  const locale = useLocale();

  const autoplayRef = useRef(
    Autoplay({
      delay: 3000,
      stopOnMouseEnter: true,
      stopOnInteraction: false,
    }),
  );
  return (
    <Carousel
      className="w-full"
      plugins={[autoplayRef.current]}
      opts={{
        loop: true,
        // align: "center",
        align: "start",
      }}
    >
      <CarouselContent>
        {banners.map((banner) => (
          <CarouselItem key={banner.id} className="basis-full lg:basis-1/2">
            <Banner banner={banner} />
          </CarouselItem>
        ))}
      </CarouselContent>

      <CarouselPrevious
        className={cn(
          "bg-primary border-none text-primary-foreground hover:bg-primary/90 hover:text-white w-6.5 h-6.5 sm:w-8 sm:h-8",
          locale === "en" ? "-left-2" : "-right-2",
        )}
      />
      <CarouselNext
        className={cn(
          "bg-primary border-none text-primary-foreground hover:bg-primary/90 hover:text-white w-6.5 h-6.5 sm:w-8 sm:h-8",
          locale === "en" ? "-right-2" : "-left-2",
        )}
      />
    </Carousel>
  );
};

export default BannersCarousel;
